import * as React from 'react';
import * as InfoCardApi from '~/Api/InfoCard';
import { useApiResult } from '~/ApiHooks';
import * as Detail from '~/InfoCard/Details';
import { Placeholder } from '~/UI';
export var Details = function (_a) {
    var _b, _c;
    var infoCardId = _a.infoCardId, yearMonthTag = _a.yearMonthTag, index = _a.index, periodType = _a.periodType;
    var _d = React.useState(new Date(yearMonthTag)), yearMonth = _d[0], setYearMonth = _d[1];
    var period = React.useMemo(function () { return new Detail.Period(new Date(yearMonth), periodType); }, [yearMonth]);
    var _e = period.getHeaders(), headers = _e[0], year = _e[1];
    var loadMore = function (action) {
        var _a = period.changePeriod(action), to = _a[1];
        setYearMonth(new Date(to));
    };
    var detailsRequest = new InfoCardApi.InfoCardDetailsRequest(infoCardId, period.searchParams);
    var detailsResult = useApiResult(detailsRequest, [infoCardId, period])[0];
    if (detailsResult.value === null && detailsResult.isLoading) {
        return <Placeholder />;
    }
    if (detailsResult.value === null) {
        return null;
    }
    var details = (_c = (_b = detailsResult.value) === null || _b === void 0 ? void 0 : _b.items) !== null && _c !== void 0 ? _c : [];
    var detailToRender = details[index];
    switch (detailToRender === null || detailToRender === void 0 ? void 0 : detailToRender.type) {
        case InfoCardApi.InfoCardDetailType.ordersInRegisterStatistics:
            return <Detail.OrdersInRegister detail={detailToRender}/>;
        case InfoCardApi.InfoCardDetailType.suppliersPackagesInOrdersStatistics:
            return (<Detail.OrderPackages detail={detailToRender} headers={headers} yearCounter={year}>
					<Detail.PeriodButtons load={loadMore} yearMonth={period.yearMonth}/>
				</Detail.OrderPackages>);
        case InfoCardApi.InfoCardDetailType.providersPackagesInOrdersStatistics:
            return (<Detail.OrderPackages detail={detailToRender} headers={headers} yearCounter={year}>
					<Detail.PeriodButtons load={loadMore} yearMonth={period.yearMonth}/>
				</Detail.OrderPackages>);
        case InfoCardApi.InfoCardDetailType.monthlyStatistics:
            return (<Detail.Monthly detail={detailToRender} headers={headers} yearCounter={year}>
					<Detail.PeriodButtons load={loadMore} yearMonth={period.yearMonth}/>
				</Detail.Monthly>);
        case InfoCardApi.InfoCardDetailType.dateStatistics:
            return <Detail.DateStatistics detail={detailToRender}/>;
        case InfoCardApi.InfoCardDetailType.indicationRestrictionPaymentStatistics:
            return (<Detail.IndicationRestrictionPayment detail={detailToRender}/>);
        case InfoCardApi.InfoCardDetailType.insuranceCompaniesPaymentStatistics:
            return <Detail.CompanyPayments detail={detailToRender}/>;
        case InfoCardApi.InfoCardDetailType.positiveListStatistics:
            return <Detail.PositiveList detail={detailToRender}/>;
        case InfoCardApi.InfoCardDetailType.packageStatistics:
            return <Detail.Packages detail={detailToRender}/>;
        case InfoCardApi.InfoCardDetailType.monthlyMultiValueStatistics:
            return (<Detail.MonthlyMultiValue detail={detailToRender} headers={headers} yearCounter={year}>
					<Detail.PeriodButtons load={loadMore} yearMonth={period.yearMonth}/>
				</Detail.MonthlyMultiValue>);
        case InfoCardApi.InfoCardDetailType.otherStatisticsLink:
            return <Detail.OtherLink detail={detailToRender}/>;
        case InfoCardApi.InfoCardDetailType.unitPricesFromRegisterStatistics:
            return <Detail.UnitPrice detail={detailToRender}/>;
        case InfoCardApi.InfoCardDetailType.monthlyPackageBalanceStatistics:
            return (<Detail.MonthlyPackageBalance detail={detailToRender} headers={headers} yearCounter={year}>
					<Detail.PeriodButtons load={loadMore} yearMonth={period.yearMonth}/>
				</Detail.MonthlyPackageBalance>);
        case InfoCardApi.InfoCardDetailType.monthlyDistrictBalanceStatistics:
            return (<Detail.MonthlyDistrictBalance detail={detailToRender} headers={headers} yearCounter={year}>
					<Detail.PeriodButtons load={loadMore} yearMonth={period.yearMonth}/>
				</Detail.MonthlyDistrictBalance>);
        default:
            return <></>;
    }
};
